export default "__VITE_ASSET__Bfn248uq__"